import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr } from "@/utils/utils";
import mapassembly from '@/view/map/custom/mapassembly';
import $ from 'jquery';
import turn from '../../../utils/turn.js';
export default {
  name: 'bookmap',
  meta: {
    title: '走进科尔沁'
  },
  components: {
    mapassembly
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      // this.$route.query.cfId
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      // this.$route.query.cdId
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      mapconfigData: {
        mapbg: '',
        logo: '',
        type: '',
        staticImg: ''
      },
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapcontainer: '',
      iconLayer: '',
      iconSource: '',
      imageLayer: '',
      wmsLayer: '',
      detail: '',
      // 定点详情对象
      swiperEl: '',
      // 弹窗轮播图ref
      typeList: [],
      // 分类列表
      currentType: 0,
      // 分类默认当前索引
      modeltype: 1,
      // 弹窗默认模板样式
      typemodel: 1,
      // 弹窗默认模板样式
      dotimgW: 100,
      // 定点图片默认宽度
      popshowflag: false,
      // 控制弹窗显隐
      mapconfigdatas: {},
      // 地图管理配置对象
      listyleobj: {},
      // 分类默认样式对象
      listobjon: {},
      // 分类选中样式对象
      // 分类搜索字段
      typesearchStr: {
        'model': 0,
        'filters': [[{
          'id': 1,
          'alias': '3',
          'compt': 'editinput',
          'express': '===',
          'val': '',
          'range': null
        }]]
      },
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      zoom: 0,
      jsonOption: {},
      mtObj: {
        title_font: 'bold 14px 微软雅黑',
        title_color: 'rgba(255,255,255,1)',
        title_bgcolor: 'rgba(0, 0, 255, 0.7)',
        title_bocolor: '',
        offsetX: 0,
        offsetY: 32,
        padding: [2, 10, 1, 10]
      },
      isApp: false,
      page: 1,
      duration: 2000,
      // 翻书过渡时间
      slideTimer: null,
      slidetime: 5000,
      // 翻书间隔时间
      dpauseTime: 5,
      pauseTime: 5,
      // 无操作停留时间
      countDown: null,
      query: ''
    };
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    if (document.body.clientWidth < 926) this.isApp = true;
    this.query = this.$route.query;
    if (this.query.duration && this.query.duration !== '') this.duration = Number(this.query.duration) * 1000;
    if (this.query.slidetime && this.query.slidetime !== '') this.slidetime = Number(this.query.slidetime) * 1000;
    window.addEventListener('click', this.wHandle.bind(this), false);
    this.getmapconfigform();
  },
  watch: {},
  methods: {
    /*
    ** 监听 倒计时 2023/11/28
    */
    wHandle(ev) {
      this.pauseTime = this.query.pausetime && this.query.pausetime !== '' ? Number(this.query.pausetime) * 60 : this.dpauseTime * 60;
      clearInterval(this.slideTimer);
      clearInterval(this.countDown);
      this.countDown = setInterval(() => {
        if (this.pauseTime >= 0) {
          --this.pauseTime;
        } else {
          clearInterval(this.countDown);
          this.flipautoplay();
        }
      }, 1000);
    },
    /*
    ** 翻书事件 2023/11/21
    */
    onTurn() {
      var that = this;
      that.$nextTick(() => {
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        that.$refs['flipbookref'].style.left = -width / 2 + 'px';
        that.$refs['flipbookref'].style.top = -height / 2 + 'px';
        $('#flipbook').turn({
          width: width,
          height: height,
          autoCenter: true,
          page: 1,
          pages: this.typeList.length,
          display: 'single',
          gradients: true,
          duration: this.duration,
          direction: 'ltr',
          when: {
            turned: function (e, page) {
              that.page = that.page === that.typeList.length ? 0 : page;
            },
            start: function (params) {
              console.log(params);
            }
          }
        });
        that.flipautoplay();
      });
    },
    /*
    ** 自动切换 2023/11/28
    */
    flipautoplay() {
      this.slideTimer = setInterval(() => {
        if (this.page === this.typeList.length) this.page = 0;
        this.page++;
        $('#flipbook').turn('page', this.page);
        this.$refs[`map${this.page}`][0].initMap(this.page);
      }, this.slidetime);
    },
    /*
    ** 导航切换
    */
    changebook(index) {
      clearInterval(this.slideTimer);
      $('#flipbook').turn('page', index + 1);
      this.$refs[`map${Number(index) + 1}`][0].initMap(Number(index) + 1);
    },
    // 获取表单字段结构 属性 分类数据
    getformstruct(val) {
      console.log(val);
      let params = {
        deptId: this.fid,
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: {
          filters: [{
            alias: "onlyid",
            compt: "editinput",
            express: '===',
            val: val.onlyid
          }],
          model: 0
        },
        orderBy: '',
        orderType: 'asc'
      };
      params.searchStr = encodeURI(JSON.stringify(params.searchStr));
      this.$api.singleadvanceSearch(params).then(res => {
        if (res.dataList.length > 0) {
          this.typeList = [];
          res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            console.log(itemformat);
            item.itemformdata = itemformat;
            this.typeList.push({
              title: itemformat.title || itemformat[1],
              value: itemformat.title || itemformat[1],
              formUserId: item.id,
              formId: item.formId,
              disabled: true,
              icon: itemformat.typeicon.length > 0 ? handleHttp(itemformat.typeicon[0].fileUrl) : '',
              id: itemformat[2]
            });
            return item;
          });
          console.log(res.dataList);
          this.typeList.unshift({
            title: ''
          });
          this.onTurn();
        }
      });
    },
    // 获取地图配置数据 方便多个地图配置
    getmapconfigform() {
      let that = this;
      this.mapconfigform.deptId = this.fid;
      this.$api.singleformUserId(this.fid, this.mapconfigform.formId, this.formUserId).then(res => {
        // console.log(res)
        that.currentformuser = res.formUserList[0];
        that.mapcfData = res.formUserList[0].formData;
        if (res.formUserList.length > 0) {
          that.mapcfData.forEach(item => {
            that.mapconfigdatas[transformStr3(item.alias)] = that.getformitemsdata(item);
          });
          document.querySelectorAll('.page').forEach(item => {
            item.style.backgroundImage = `url(${that.mapconfigdatas.backgroundImg})`;
          });
          that.getformstruct(that.mapconfigdatas);
        }
      });
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    }
  }
};